import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Heading,
	HStack,
	Input,
	Textarea,
} from '@chakra-ui/react';
import { format } from '../utils';
import { options } from './data';

export const CustomerLog = ({
	admin,
	id,
	wakeLog,
	setWakeLog,
	onUserClose,
}) => {
	const [amount, setAmount] = useState(0);
	const [content, setContent] = useState('');

	const [loading, setLoading] = useState(true);
	const [logs, setLogs] = useState([]);

	useEffect(() => {
		let active = true;
		async function load() {
			const res = await axios.get(`/logs/${id}`, options());
			if (!active) {
				return;
			}
			setLogs(res.data.logs);
			setLoading(false);
		}
		load();

		return () => {
			active = false;
		};
	}, [id, wakeLog]);

	const contentLabel = amount ? 'Reason' : 'Memo';
	const buttonTxt = amount ? 'Payment' : 'Memo';
	const noMemo = content.length < 1;

	const handleCreate = () => {
		axios({
			method: 'post',
			url: `/logs`,
			data: {
				author: admin,
				customer: id,
				amount,
				content,
			},
			...options(),
		})
			.then(() => {
				if (onUserClose) return onUserClose();
				setAmount(0);
				setContent('');
				setWakeLog(new Date());
			})
			.catch(console.log);
	};

	if (loading) return <p>Loading...</p>;

	return (
		<Box>
			<Heading py={4} fontSize={'xl'}>
				Customer log
			</Heading>
			{logs.map(({ created_at, author, content }) => {
				const when = moment(created_at).format('DD.MM.YY HH:mm:ss');
				return (
					<Box borderBottom="1px solid #ccc" p={2}>
						<span>{`${when} `}</span>
						<strong>{`${author} `}</strong>
						{format(content)}
					</Box>
				);
			})}
			<HStack pt={4} alignItems="top">
				<FormControl w="12%">
					<FormLabel>Amount</FormLabel>
					<Input
						type="number"
						min="0"
						placeholder="Amount"
						value={amount}
						onChange={e => setAmount(e.target.value)}
					/>
				</FormControl>
				<FormControl w="66%">
					<FormLabel>{contentLabel}</FormLabel>
					<Textarea
						value={content}
						onChange={e => setContent(e.target.value)}
						size="sm"
					/>
				</FormControl>
				<FormControl w="22%">
					<FormLabel>{`${buttonTxt} record`}</FormLabel>
					<Button
						d="block"
						w="100%"
						colorScheme="blue"
						onClick={handleCreate}
						disabled={noMemo}
					>
						Create
					</Button>
				</FormControl>
			</HStack>
		</Box>
	);
};
